import { render, staticRenderFns } from "./TablePermissionsPage.vue?vue&type=template&id=24e2828c&scoped=true"
import script from "./TablePermissionsPage.vue?vue&type=script&lang=js"
export * from "./TablePermissionsPage.vue?vue&type=script&lang=js"
import style0 from "./TablePermissionsPage.vue?vue&type=style&index=0&id=24e2828c&prod&scoped=true&lang=scss"
import style1 from "./TablePermissionsPage.vue?vue&type=style&index=1&id=24e2828c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e2828c",
  null
  
)

export default component.exports